export enum UserRole {
  Admin = 'admin',
  Operator = 'operator',
  Trader = 'trader',
  Merchant = 'merchant',
  MerchantOperator = 'merchant_operator',
  TechOperator = 'tech_operator',
}
